import axios from 'axios';


class AuthService {
    login(user) {
        return axios
            .post(window.api_url + '/api/auth/login', user
            )
            .then(response => {
                if (response.data.access_token) {
                    localStorage.setItem('user', JSON.stringify(response.data));
                }

                return response.data;
            });
    }

    logout() {
        localStorage.removeItem('user');
    }

    register(user) {
        return axios.post(window.api_url + '/api/auth/signup', user);
    }

    resetPassword(user) {
        return axios.post(window.api_url + '/api/auth/reset/password', user);
    }

    forgotPassword(user) {
        return axios.post(window.api_url + '/api/auth/forgot/password', user);
    }
}

export default new AuthService();